var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import classNames from 'classnames';
var ClickableDate = /** @class */ (function (_super) {
    __extends(ClickableDate, _super);
    function ClickableDate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClickableDate.prototype.componentDidMount = function () {
        if (this.props.focusOnMount) {
            this.focusIfNeeded();
        }
    };
    ClickableDate.prototype.componentDidUpdate = function () {
        this.focusIfNeeded();
    };
    ClickableDate.prototype.focusIfNeeded = function () {
        var _a;
        var _b = this.props, calendarButtonState = _b.calendarButtonState, isFocusingHeader = _b.isFocusingHeader, dateButtonRef = _b.dateButtonRef;
        if (calendarButtonState.isFocus && !isFocusingHeader) {
            (_a = dateButtonRef === null || dateButtonRef === void 0 ? void 0 : dateButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    ClickableDate.prototype.dateClassName = function () {
        var _a = this.props, calendarButtonState = _a.calendarButtonState, isFocusingHeader = _a.isFocusingHeader;
        var isEnabled = calendarButtonState.isEnabled, isFocus = calendarButtonState.isFocus, isSelected = calendarButtonState.isSelected, isToday = calendarButtonState.isToday;
        return classNames({
            'ffe-calendar__date': true,
            'ffe-calendar__date--today': isToday,
            'ffe-calendar__date--focus': isFocus && !isFocusingHeader,
            'ffe-calendar__date--disabled': !isEnabled,
            'ffe-calendar__date--selected': isSelected,
            'ffe-calendar__date--disabled-focus': !isEnabled && isFocus,
        });
    };
    ClickableDate.prototype.tabIndex = function () {
        return this.props.calendarButtonState.isFocus ? 0 : -1;
    };
    ClickableDate.prototype.render = function () {
        var _a = this.props, calendarButtonState = _a.calendarButtonState, headers = _a.headers, onClick = _a.onClick, locale = _a.locale, dateButtonRef = _a.dateButtonRef, month = _a.month, year = _a.year;
        var monthName = locale === 'en' ? month : month.toLowerCase();
        return (React.createElement("td", { className: "ffe-calendar__day", headers: headers, role: "button", ref: dateButtonRef, "aria-disabled": !calendarButtonState.isEnabled, "aria-current": calendarButtonState.isSelected, "aria-label": "".concat(calendarButtonState.dayInMonth, ". ").concat(monthName, " ").concat(year), tabIndex: this.tabIndex(), onClick: function () { return onClick(calendarButtonState); } },
            React.createElement("span", { className: this.dateClassName(), "aria-hidden": "true" }, calendarButtonState.dayInMonth)));
    };
    return ClickableDate;
}(Component));
export { ClickableDate };
